import { r as a, c as o, h as i, H as n } from "./main-bb89b2f2.js";
import { $ as r } from "./screen.store-835df690-461bc8b5.js";
import "vue";
import "./toNumber-f405d8e0-e5c83f11.js";
const s = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}.flex{display:flex}.flex-wrap{flex-wrap:wrap}:host{display:block}.main-navigation{background-color:var(--mainNavigation-surface-default);box-sizing:border-box;display:flex;flex-direction:row;flex-wrap:wrap;gap:32px;height:100%;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.main-navigation.mobile{background-color:var(--color-white);flex-direction:column;gap:0;padding-bottom:20px}.static{position:static}", l = s, c = class {
  constructor(e) {
    a(this, e), this.lhHeaderComponentRegister = o(this, "lhHeaderComponentRegister", 7), this.listOfItems = [];
  }
  /**
   * Child components are registered
   * @param evt
   */
  registerMainNavigationItems(e) {
    e.stopImmediatePropagation(), this.listOfItems.push(e.target);
  }
  /**
   * If subid is set on main navigation item this event is emitted
   * @param evt
   */
  toggleMobileMenu(e) {
    this.listOfItems.map((t) => {
      t != e.target && (t.submenuActive = !1);
    }), e.detail !== "" && e.detail.subId && (e.target.submenuActive = !0);
  }
  /**
   * all child components are deactivated
   */
  async deactivateItems() {
    this.listOfItems.map((e) => {
      e.submenuActive = !1;
    });
  }
  /**
   * return a item with a specific subid
   */
  async getItemBySubid(e) {
    for (const t of this.listOfItems)
      if (t.subid === e)
        return t;
    return null;
  }
  componentWillLoad() {
    this.lhHeaderComponentRegister.emit("main-navigation");
  }
  render() {
    const e = {
      "main-navigation": !0,
      mobile: r.lgAndDown
    };
    return i(n, { key: "ab3a7cc7149e17f154545dd08893c6961e72aaa6" }, i("div", { key: "79a0fd6c8dae745e848c68bed7bf22a095433fe6", class: e }, i("slot", { key: "6191765298bf3a86c100d8e152e1c36e28215e03" })));
  }
};
c.style = l;
export {
  c as patternlib_main_navigation_portal
};
